module.exports = __webpack_public_path__ + "img/alterexploringlogo.84632b74.jpg";